import React, { Component } from "react";
import { Badge, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from "reactstrap";
import style from "./Account.module.scss";

class Requeriments extends Component {
  constructor(props) {
    super(props);
    if (props.hasFile) {
      this.state = {
        open: false,
        text: "",
        uploaded: true,
      };
    } else {
      this.state = {
        open: false,
        text: "",
        uploaded: false,
      };
    }
  }

  toggle = (save) => {
    if (save) {
      this.handleFileUpload(this.state.text);
    }

    this.setState({ open: !this.state.open, text: "" });
  };

  resetState = () => {
    const { setAttachment, onChangeOrder } = this.props;
    setAttachment({
      file: null,
    });
    onChangeOrder({
      AttachmentFileName: undefined,
      AttachmentFileType: undefined,
      HasFileUploadPending: undefined,
      AttachmentFileUploadPending: undefined,
    });
    this.setState({ open: false, text: "", uploaded: false });
  };

  onChangeText = (text) => {
    this.setState({ text });
  };

  handleFileUpload = (event) => {
    const { setAttachment, onChangeOrder } = this.props;

    if (typeof event == "string") {
      setAttachment({
        file: new Blob([event], { type: "plain/text", endings: "native" }),
      });
    } else {
      setAttachment({ file: event.target.files[0] });
    }

    onChangeOrder({
      AttachmentFileName: Math.random().toString(36).substring(9),
      AttachmentFileType: "none",
    });

    this.setState({ uploaded: true });
  };

  render() {
    const { orderId, accountId, orderPdf, readonly, hasAttachment, downloadAttachment } = this.props;
    const { open, text, uploaded } = this.state;

    const attachmentInServer = hasAttachment && !hasAttachment.hasOwnProperty("uploadPending");

    return (
      <div className={style.requeriments}>
        {orderId && (
          <div className={style.line}>
            <span>Download order as pdf</span>
            <button
              className={`mr-1 btn btn-light ${style.pdf}`}
              tooltip="Download PDF"
              tooltip-position="bottom"
              onClick={() => orderPdf({ orderId })}
            >
              <img />
            </button>
          </div>
        )}

        <div className={style.line}>
          <span>Attachment</span>

          {!readonly && !this.state.uploaded && (
            <button
              className={`mr-1 btn btn-light ${style.upload}`}
              tooltip="Upload file"
              tooltip-position="bottom"
              visible={this.state.uploaded}
            >
              <img />
              <input type="file" className={style.inputFile} onChange={this.handleFileUpload} />
            </button>
          )}

          {!readonly && !this.state.uploaded && (
            <button
              className={`mr-1 btn btn-light ${style.pencil}`}
              tooltip="Enter text"
              tooltip-position="bottom"
              onClick={() => this.toggle()}
            >
              <i className={"fa fa-pencil"}></i>
            </button>
          )}
          {!readonly && this.state.uploaded && (
            <button
              className={`mr-1 btn btn-light ${style.pencil}`}
              tooltip="Remove attachment"
              tooltip-position="bottom"
              onClick={() => this.resetState()}
            >
              <i className={"fa fa-times"}></i>
            </button>
          )}

          {!attachmentInServer && (
            <Badge
              color={uploaded || (hasAttachment && hasAttachment.uploadPending) ? "success" : "warning"}
              className={style.pending}
            >
              {uploaded || (hasAttachment && hasAttachment.uploadPending) ? "Uploaded" : "Pending"}
            </Badge>
          )}
          {attachmentInServer && (
            <button className="link" onClick={() => downloadAttachment({ orderId, accountId })}>
              download
            </button>
          )}
        </div>

        <ModalText toggle={(e) => this.toggle(e)} open={open} text={text} onChangeText={this.onChangeText} />
      </div>
    );
  }
}

const ModalText = ({ toggle, open, text, onChangeText }) => (
  <Modal isOpen={open} toggle={toggle} className={style.modal}>
    <ModalHeader toggle={() => toggle()}>Attachment</ModalHeader>
    <ModalBody>
      <Input
        type={"textarea"}
        rows={2}
        placeholder={"Text"}
        value={text}
        onChange={(e) => onChangeText(e.target.value)}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={() => toggle()}>
        Cancel
      </Button>{" "}
      <Button color="primary" onClick={() => toggle(true)}>
        Save
      </Button>
    </ModalFooter>
  </Modal>
);

export default Requeriments;
